import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricMissedParticipationCount extends MetricBase {
    constructor() {
        super({
            field: "metric_missedParticipationCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.missedParticipationCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.missedParticipationCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.missedParticipationCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricMissedParticipationCount;
